import { TRootState } from 'Redux/Reducers';

export const getAppUserCount = (state: TRootState) => state.appUser.maxCount;
